import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../context';
import './PluginManager.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile } from '@fortawesome/free-solid-svg-icons';
import PluginManagerHeader from './PluginManagerHeader';
import moment from 'moment';
import { Facebook } from 'react-spinners-css';

const page = 1;

const PluginList = (props) => {
    const { openPluginDetails } = props;

    const dispatch = useDispatch();

    const [isLoading, setIsLoading] = useState(true);

    const {
        includeTestPlugins,
        includeInactivePlugins,
        pluginFilter,
        pimsFilter,
        isConnectPluginDetailModalOpen,
    } = useSelector(
        (state) => ({
            includeTestPlugins: state.missionControl.includeTestPlugins,
            includeInactivePlugins: state.missionControl.includeInactivePlugins,
            pluginFilter: state.missionControl.pluginFilter,
            pimsFilter: state.missionControl.pimsFilter,
            isConnectPluginDetailModalOpen:
                state.toggle.isConnectPluginDetailModalOpen,
        }),
        shallowEqual
    );

    const [plugins, setPlugins] = useState([]);

    const openPluginDetailModal = (pluginId) => {
        openPluginDetails();
        dispatch(actions.missionControl.setEditModalCurrentPluginId(pluginId));
    };

    useEffect(() => {
        setIsLoading(true);
        dispatch(
            actions.missionControl.getPlugins(
                includeTestPlugins,
                includeInactivePlugins,
                pluginFilter,
                pimsFilter,
                page
            )
        ).then((res) => {
            const newPluginList = res?.data || [];
            setPlugins(newPluginList);
            setIsLoading(false);
        });

        // eslint-disable-next-line
    }, [
        dispatch,
        includeTestPlugins,
        includeInactivePlugins,
        pluginFilter,
        pimsFilter,
        isConnectPluginDetailModalOpen,
    ]);

    const getDefaultVersion = (plugin) => {
        if (plugin === null || plugin?.defaultVersion === null) {
            return '';
        }

        return (
            <>
                {plugin?.defaultVersion?.version}
                <br />
                <small>
                    {'Release Date: ' +
                        moment
                            .utc(plugin?.defaultVersion?.releaseDate)
                            .local()
                            .format('M/D/YYYY LT')}
                </small>
            </>
        );
    };

    return (
        <Row className="sc-glass shadow text-light sc-rounded px-2 py-4 mb-4">
            <>
                <Col lg="12" md="12" sm="12" className="p-0">
                    <section className="content">
                        <div className="plugincard">
                            <div className="plugincard-header">
                                <h3 className="plugincard-title">Plugins</h3>
                            </div>
                            <div
                                className="plugincard-body table-responsive p-0"
                                style={{
                                    minHeight: '200px',
                                    maxHeight: '300px',
                                }}>
                                {isLoading ? (
                                    <h2 className="m-4 text-center">
                                        <Facebook color="#6F7378" />
                                    </h2>
                                ) : (
                                    <table className="table table-striped table-plugin-head-fixed plugins">
                                        <PluginManagerHeader />
                                        <tbody>
                                            {(plugins || []).map((p, x) => (
                                                <tr key={p.id}>
                                                    <td>#</td>
                                                    <td>
                                                        {p.name}
                                                        <br />
                                                        <small>
                                                            Uid: {p.id}
                                                        </small>
                                                    </td>
                                                    <td>
                                                        {getDefaultVersion(p)}
                                                    </td>
                                                    <td>
                                                        {
                                                            p?.defaultVersion
                                                                ?.description
                                                        }
                                                    </td>
                                                    <td className="project-actions text-center">
                                                        <Button
                                                            className="btn btn-list-primary"
                                                            title="View Plugin Detail"
                                                            onClick={() => {
                                                                openPluginDetailModal(
                                                                    p.id
                                                                );
                                                            }}>
                                                            <FontAwesomeIcon
                                                                icon={faFile}
                                                            />
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                    </section>
                </Col>
            </>
        </Row>
    );
};

export default React.memo(PluginList);
